import { render, staticRenderFns } from "./UploadTicketCode.vue?vue&type=template&id=c0dacec2&scoped=true"
import script from "./UploadTicketCode.vue?vue&type=script&lang=js"
export * from "./UploadTicketCode.vue?vue&type=script&lang=js"
import style0 from "./UploadTicketCode.vue?vue&type=style&index=0&id=c0dacec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dacec2",
  null
  
)

export default component.exports